import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core'

import { MovieService } from '../shared/movie.service'
import { Movie, ShowtimeType, Showtime, Theatre } from '../shared/movie.model'

import { Observable } from 'rxjs/Rx'
import { TranslateService } from '@ngx-translate/core'

import * as moment from 'moment'

@Component({
  selector: 'cm-movie-showtime-list',
  templateUrl: './movie-showtime-list.component.html',
  styleUrls: ['./movie-showtime-list.component.css'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class MovieShowtimeListComponent implements OnInit {

  // @Input() showtimes: ShowtimesByTheatre[]
  @Input() movie: Movie

  constructor(private movieService: MovieService,
    private translate: TranslateService) { }

  ngOnInit() {
  }

  getShowtimeType(type: ShowtimeType): string {
    return ShowtimeType.toString(type)
  }

  getDatetimes(showtimes: Showtime[]): moment.Moment[] {
    return showtimes.map((showtime: Showtime) => showtime.datetime)
  }

  getTheatreDistance(theatre: Theatre): Observable<number> {
    console.log(theatre.id)
    return this.movieService.getTheatre(theatre.id)
      .map((response: Theatre) => response.distance)
  }

  getComingSoonImage() {
    const lang = this.translate.currentLang.toLowerCase()

    switch (lang) {
      case 'fr':
        return '../../../assets/img/movies/coming_soon_fr.png'
      case 'es':
        return '../../../assets/img/movies/coming_soon_es.png'
      case 'en':
      default:
        return '../../../assets/img/movies/coming_soon_en.png'
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/movies/movie-showtime-list/movie-showtime-list.component.ts